import money from '@free2move/money';
import Vue from 'vue';
import Vuex from 'vuex';
import dayjs from 'dayjs';
import store from '@/store/index';
import App from './App.vue';
import i18n from './i18n/i18n';
import cookie from 'js-cookie'
import '@/directives';
import 'leaflet/dist/leaflet.css';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/nl';

import { Tracking } from '@meeseeks/centaur-tracking'

const configUserCentric = {
    usercentrics: {
        ucId: 'q6vL_KT2u3vGux'
    },
    gtm: {
        analyticsId: 'GTM-NF366VX',
    }
};

const scripts = new Tracking().toHTML(configUserCentric);

import getRouter from './router/index';

import '@free2move/vuejs-components/vuejs-components.css';
import '@/assets/css/freakflags.css';
import getApi from '@/lib/axios/authAxiosInstance';

// get language from URL
const languageMatch = window.location.pathname.match(/\/([a-z]{2})-/);

let language = languageMatch ? languageMatch[1] : undefined;

if (!language) {
    // get language from cookies
    language = cookie.get('fpa-language');
} else {
    // set language in cookies
    cookie.set('fpa-language', language);
}

//get country from URL
const countryMatch = window.location.pathname.match(/-([A-Z]{2})\//);
let country = countryMatch ? countryMatch[1] : undefined;

if (!country) {
    country = cookie.get('fpa-country');
} else {
    // set country in cookies
    cookie.set('fpa-country', country);
}

Vue.config.productionTip = false;
Vue.prototype.$money = money;
Vue.prototype.$language = language || 'en'
Vue.prototype.$country = country || 'GB';
Vue.prototype.$baseUrl = '';
Vue.prototype.$appBaseUrl = '/user/personal-account';
Vue.prototype.$alternateLinksOthers = [];
Vue.prototype.$alternateLinks = [];
Vue.prototype.$canonicalLink = [];

const prefixUrl = `/${Vue.prototype.$language}-${Vue.prototype.$country}`;

dayjs.locale('fr');

Vue.use(Vuex);

const vuexStore = new Vuex.Store(store);
const router = getRouter({prefixUrl, language: Vue.prototype.$language, country: Vue.prototype.$country, store: vuexStore});

getApi('/', router);


// iterate on scripts and append them to the head
scripts.forEach((script: any) => {
    // create a DOM element script from the string (the string is <script> tag) get all attributes and append them to the new script
    const scriptElement = document.createElement('script');
    // extract all attributes from the script with DOM parser
    const parser = new DOMParser();
    const doc = parser.parseFromString(script, 'text/html');
    const attributes = doc.querySelector('script')?.attributes;
    // iterate on the attributes and append them to the new script
    if (attributes) {
        for (let i = 0; i < attributes.length; i++) {
            scriptElement.setAttribute(attributes[i].name, attributes[i].value);
        }
    }

    // put innerhtml script atribute inside script
    scriptElement.innerHTML = doc.querySelector('script')?.innerHTML || '';

    // append the script to the head
    document.head.appendChild(scriptElement);
});

new Vue({
    i18n,
    router,
    store: vuexStore,
    render: (h) => h(App),
}).$mount('#front-personal-account');
